// Nederlandse datumlabels voor `days[]` (ONTWERP.md §5.5: `long_date_nl`, `weekday_short`).
// Bewust zonder Intl-locale-afhankelijkheid: de labels zijn contract, niet ICU-uitvoer.
import { parseLocalDate, weekdayOf } from '../recurrence/localDate.js';
const WEEKDAY_SHORT_NL = {
    MO: 'ma',
    TU: 'di',
    WE: 'wo',
    TH: 'do',
    FR: 'vr',
    SA: 'za',
    SU: 'zo',
};
const WEEKDAY_LONG_NL = {
    MO: 'maandag',
    TU: 'dinsdag',
    WE: 'woensdag',
    TH: 'donderdag',
    FR: 'vrijdag',
    SA: 'zaterdag',
    SU: 'zondag',
};
const MONTH_LONG_NL = [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
];
/** `ma` … `zo`. */
export function weekdayShortNl(date) {
    return WEEKDAY_SHORT_NL[weekdayOf(date)];
}
/** `woensdag 23 september 2026`. */
export function longDateNl(date) {
    const { year, month, day } = parseLocalDate(date);
    return `${WEEKDAY_LONG_NL[weekdayOf(date)]} ${day} ${MONTH_LONG_NL[month - 1]} ${year}`;
}
/** `dinsdag` (voluit, kleine letter). */
export function weekdayLongNl(weekday) {
    return WEEKDAY_LONG_NL[weekday];
}
/** `januari` … `december` (month 1-12). */
export function monthLongNl(month) {
    return MONTH_LONG_NL[month - 1] ?? '';
}
/** `30 juni 2027` (zonder weekdag). */
export function dateNl(date) {
    const { year, month, day } = parseLocalDate(date);
    return `${day} ${monthLongNl(month)} ${year}`;
}
//# sourceMappingURL=nl.js.map